import axios from "axios";
import { API_URL } from "../../utils/api-utils";
import { common } from "../../utils";
//Master
export const GetListEncryptMapMaster = async (param) => {
  let url = `${API_URL.Loader}/api/master/GetListEncryptMapMaster`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DeleteEncryptMap = async (param) => {
  let url = `${API_URL.Loader}/api/master/DeleteEncryptMap`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const SaveEncryptMap = async (param) => {
  let url = `${API_URL.Loader}/api/master/SaveEncryptMap`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

  

  